<template>
    <div>
      <div class="content-header row">
        <div class="content-header-left col-md-6 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <h2 class="content-header-title float-start mb-0">
              Amenity Master
            </h2>
          </div>
        </div>
        <div class="content-header-right col-md-6 col-12 mb-2">
          <div class="col-12">
            <div class="breadcrumb-wrapper">
              <ol class="breadcrumb float-end">
                <li class="breadcrumb-item">
                  <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Amenity Master</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section id="dashboard-ecommerce">
          <div class="row match-height">
            <div class="col-xl-12 col-md-12 col-12">
              <div class="card card-congratulation-medal">
                <div class="card-body">
                  <div class="row mb-1">
                    <div class="d-flex col-12">
                      <div class="float-start col-6">
                        <div class="input-group input-group-merge w-50">
                          <span class="input-group-text" id="basic-addon-search2"
                            ><vue-feather type="search"></vue-feather></span>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Search..."
                            aria-label="Search..."
                            aria-describedby="basic-addon-search2"
                            v-model="search"
                            @keyup="searchData"
                          />
                        </div>
                      </div>
                      <!-- data-bs-toggle="modal"
                      data-bs-target="#modals-slide-in" -->
                      <div class="float-end col-6">
                        <button
                          type="button"
                          class="btn btn-gradient-primary float-end"
                          @click="add"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  <section id="ajax-datatable">
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-datatable">
                            <table
                              class="dt-column-search table table-responsive"
                            >
                              <thead>
                                <tr>
                                  <template v-for="head in header" :key="head">
                                    <th>{{ head }}</th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-show="list.length > 0" v-for="(li, index) in list" :key="li.id">
                                  <td>{{ index + paginationData.from }}</td>
                                  <td>{{ li.amenity_name }}</td>
                                  <td>{{ li.price }}</td>
                                  <td>{{ tConvert(li.time) }}</td>
                                  <td>{{ li.notes }}</td>
                                  <td>{{ li.deposit_amount }}</td>
                                  <td>{{ li.created_at }}</td>
                                  <td>{{ li.updated_at }}</td>
                                  <td class="d-flex">
                                    <div
                                      class="d-flex justify-content-start align-items-center mb-75"
                                    >
                                      <span class="me-75">
                                        <div
                                          class="avatar bg-light-primary rounded"
                                          @click="edit(li.id)"
                                        >
                                          <div class="avatar-content">
                                            <vue-feather type="edit" size="15"></vue-feather>
                                          </div>
                                        </div>
                                      </span>
                                    </div>
                                    <div
                                      class="d-flex justify-content-start align-items-center mb-75"
                                    >
                                      <span class="me-75">
                                        <div
                                          class="avatar bg-light-danger rounded"
                                          @click="deleteDes(li.id)"
                                        >
                                          <div class="avatar-content">
                                            <vue-feather type="trash-2" size="15"></vue-feather>
                                          </div>
                                        </div>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                                <tr v-show="list.length === 0">
                                  <td colspan="9" class="text-center">No Data Found</td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <template v-for="head in header" :key="head">
                                    <th>{{ head }}</th>
                                  </template>
                                </tr>
                              </tfoot>
                            </table>
                            <div class="row d-flex">
                              <div class="col-12 d-flex">
                                <div class="col-6 showing_entry">
                                  Showing {{ paginationData.from }} to
                                  {{ paginationData.to }} of
                                  {{ paginationData.total }} entries
                                </div>
                                <div class="col-6">
                                  <Pagination
                                    :data="paginationData"
                                    @pagination-change-page="getResults"
                                    show-disabled="true"
                                    limit="3"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <teleport to="#modal">
      <div class="modal modal-slide-in new-user-modal fade" id="modals-slide-in" :class="isShow" :style="{display: isDisplay}">
        <div class="modal-dialog">
          <form
            class="add-new-user modal-content pt-0"
            method="post"
            @submit.prevent="submitForm"
          >
            <input type="hidden" name="id" :v-modal="id" />
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="[isShow='', isDisplay='none']"
            >
              ×
            </button>
            <div class="modal-header mb-1">
              <h4 class="modal-title" id="exampleModalLabel">
                {{ modalName }} Amenity Master
              </h4>
            </div>
            <div class="modal-body flex-grow-1">
               <div class="mb-1">
                <label class="form-label" for="basic-addon-name">Aminity Name</label>
                <input
                    type="text" class="form-control" name="amenity_name" v-model="form.amenity_name" placeholder="Aminity Name" @keyup="
                    form.amenity_name.length > 0
                        ? [(amenityNameError = 'none'), (this.disabled = false)]
                        : (amenityNameError = 'block')
                    "/>
                <div class="invalid-feedback fw-bold fst-italic" :style="{display: amenityNameError}" > Please enter Aminity name. </div>
              </div>
              <div class="mb-1">
                <label class="form-label" for="basic-addon-name">Price</label>
                <input
                    type="number" class="form-control" name="price" v-model="form.price" id="price" step="any" placeholder="Price" @keyup="
                    form.price.toString().length > 0
                        ? [(priceError = 'none'), (disabled = false)]
                        : (priceError = 'block')
                    "/>
                <div class="invalid-feedback fw-bold fst-italic" :style="{display: priceError}" > Please enter price. </div>
              </div>
              <div class="mb-1">
                <label class="form-label" for="basic-addon-name">Time</label>
                <input
                    type="time" class="form-control" name="time" step="2" v-model="form.time" id="time" placeholder="Time" @keyup="
                    form.time.toString().length > 0
                        ? [(timeError = 'none'), (disabled = false)]
                        : (timeError = 'block')
                    "/>
                <div class="invalid-feedback fw-bold fst-italic" :style="{display: timeError}" > Please enter Time. </div>
             </div>
             <div class="mb-1">
              <label class="form-label" for="basic-addon-name">Notes</label>
              <textarea class="form-control" name="notes" v-model="form.notes" placeholder="Notes" @keyup="
                  form.notes.length > 0
                    ? [(notesError = 'none'), (this.disabled = false)]
                    : (notesError = 'block')
                "></textarea>
              <div class="invalid-feedback fw-bold fst-italic" :style="{display: notesError}" > Please enter Address. </div>
            </div>
            <div class="mb-1">
            <label class="form-label" for="basic-addon-name">Deposit Amount</label>
            <input
                type="number" class="form-control" name="deposit_amount" v-model="form.deposit_amount" id="deposit_amount" step="any" placeholder="Deposit Amount"/>
            <div class="invalid-feedback fw-bold fst-italic" :style="{display: depositAmountError}" > Please enter Deposit Amount. </div>
            </div>
            <div class="mb-1">
              <label class="form-label" for="basic-addon-gate">Gates</label>
              <Select2
                  v-model="form.gate_id"
                  :options="gates"
                  :settings="{
                    placeholder: 'Choose Gate',
                  }"
              />
            </div>
              <button
                type="submit"
                class="btn btn-primary me-1 data-submit"
                :disabled="disabled"
              >
                Submit
              </button>
              <button
                type="reset"
                class="btn btn-outline-secondary"
                :disabled="disabled"
                data-bs-dismiss="modal"
                @click="[isShow='', isDisplay='none']"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </teleport>
  </template>
  
  <script>
  import axios from "axios";
  import LaravelVuePagination from "laravel-vue-pagination";
  import Select2 from "vue3-select2-component";
  import Form from 'vform';
  
  export default {
    name: "Amenity",
    components: {
      Pagination: LaravelVuePagination,
      Select2
    },
    data() {

      return {
        form: new Form({
            id: null,
            amenity_name: "",
            price: "",
            time: "",
            notes: "",
            deposit_amount: "",
            gate_id: "",
        }),
        response: "",
        disabled: false,
        header: [],
        list: [],
        modalName: "Add",
        paginationData: {},
        search: null,
        gates: [],
        amenityNameError: "none",
        priceError: "none",
        timeError: "none",
        notesError: "none",
        depositAmountError: "none",
        isShow: "",
        isDisplay: "none",
        token: localStorage.getItem('auth_token')
      };
    },
    async mounted() {
      this.header = [
        "Sr. no.",
        "Amenity Name",
        "Price",
        "Time",
        "Notes",
        "Deposit Amount",
        "Created Date",
        "Updated Date",
        "Action",
      ];
      this.getEntryGates();
      this.getResults();
    },
    methods: {
      async add() {
        (this.form.id = null),
        (this.form.amenity_name = ""),
        (this.form.price = ""),
        (this.form.time = ""),
        (this.form.notes = ""),
        (this.form.deposit_amount = ""),
        (this.form.gate_id = ""),
        (this.response = "");
        this.isShow = "show"
        this.isDisplay = "block"
      },
      async getEntryGates() {
        await axios.get(process.env.VUE_APP_API_URL+"/entry-exit-name", 
          {
            headers: {
              "Content-Type": "application/json",
              'Accept': "application/json",
              "Authorization": `Bearer ${this.token}`
            }
          })
          .then((response) => {
            this.gates = response.data.data;
          });
      },
      async getResults(page = 1) {
        await axios.get(process.env.VUE_APP_API_URL+"/amenity_master?page=" + page, 
          {
            headers: {
              "Content-Type": "application/json",
              'Accept': "application/json",
              "Authorization": `Bearer ${this.token}`
            }
          })
          .then((response) => {
            this.paginationData = response.data.data;
          });
        this.list = this.paginationData.data;
      },
      async submitForm() {
        this.disabled = true;
        if (this.form.amenity_name.length === 0) {
          this.amenityNameError = "block";
        } else if (this.form.price.toString().length === 0) {
          this.priceError = "block";
        } else if (this.form.time.length === 0) {
          this.timeError = "block";
        } else if (this.form.notes.length === 0) {
          this.notesError = "block";
        } 
        // else if (this.form.deposit_amount.toString().length === 0) {
        //   this.depositAmountError = "block";
        // } 
        else {

          if (this.form.id) {
            await this.form.put(process.env.VUE_APP_API_URL+"/amenity_master/" + this.form.id,
            {
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${this.token}`
              },
            })
            .then((response) => {
              if (response.data.status) {
                this.$toast.success(response.data.message);
                this.isShow = ""
                this.isDisplay = "none"
                this.disabled = false;
                this.getResults();
              } else {
                this.$toast.error(response.data.error?.[0]);
                this.disabled = false;
              }
            })
            .catch((error) => {
              this.$toast.error(error);
              this.disabled = false;
            });
          } else {
            await this.form.post(process.env.VUE_APP_API_URL+"/amenity_master",
              {
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "Authorization": `Bearer ${this.token}`
                },
              })
              .then((response) => {
                if (response.data.status) {
                  this.$toast.success(response.data.message);
                  this.isShow = ""
                  this.isDisplay = "none"
                  this.disabled = false;
                  this.getResults();
                } else {
                  this.$toast.error(response.data.error?.[0]);
                  this.disabled = false;
                }
              })
              .catch((error) => {
                this.$toast.error(error);
                this.disabled = false;
              });
          }
        }
      },
      deleteDes(id) {
        this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ms-1",
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            axios
              .delete(process.env.VUE_APP_API_URL+"/amenity_master/" + id,
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${this.token}`
                  },
                }
              )
              .then(response => {
                this.getResults();
                if (response.data.status) {
                  this.$toast.success(response.data.message);
                } else {
                  this.$toast.error(response.data.error?.[0]);
                }
              })
              .catch((error) => {
                this.$toast.error(error);
              });
          }
        });
      },
      async edit(id) {
        this.tags = [];
        this.amenityNameError = "none";
        this.priceError = "none";
        this.timeError = "none";
        this.notesError = "none";
        this.depositAmountError = "none";
        this.disabled = false

        const output = await axios.get(process.env.VUE_APP_API_URL+"/amenity_master" +(id ? "/" + id : ""),
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${this.token}`
                  },
                });
                console.log(output)
        this.form.id = output.data.data?.id;
        this.form.amenity_name = output.data.data?.amenity_name;
        this.form.price = output.data.data?.price;
        this.form.time = output.data.data?.time;
        this.form.notes = output.data.data?.notes;
        this.form.deposit_amount = output.data.data?.deposit_amount;
        this.form.gate_id = output.data.data?.gate_id;
        
        this.modalName = "Edit";
        this.isShow = "show"
        this.isDisplay = "block"
      },
      async searchData() {
        await axios
          .post(process.env.VUE_APP_API_URL+"/amenity_master/search",
            {
              search: this.search,
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${this.token}`
              },
            }
          )
          .then((response) => {
            if (response.data.status) {
              this.list = response.data.data.data;
              this.isShow = ""
              this.isDisplay = "none"
            } else {
              this.$toast.error(response.data.error?.[0]);
            }
          })
          .catch((error) => {
            this.$toast.error(error);
          });
      },
      tConvert (time) {
            // Check correct time format and split into components
            time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

            if (time.length > 1) { // If time format correct
                time = time.slice (1);  // Remove full string match value
                time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join (''); // return adjusted time or original string
        }   
    },
  };
  </script>